




import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashboardControl, ResourceManager } from 'devexpress-dashboard';
import DevExpress from '@devexpress/analytics-core';
import { DashboardMenuItem } from 'devexpress-dashboard/designer';
import ScreenService from '@/services/ScreenService';
import Screen from '@/models/Screen';

@Component
export default class ScreenViewer extends Vue {
    private Id: number = 0;
    private dashboardControl: any;
    private Model: Screen = new Screen();

    constructor() {
        super();
        this.dashboardControl = {};
    }
    private async created() {
        console.log('aaa');
        this.Id = parseInt(this.$route.params['id'], 10);
        await this.LoadScreen();
        this.mount();
    }

    private async LoadScreen() {
        const screenService = new ScreenService();
        const response = await screenService.LoadScreen(this.Id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private mount() {
        console.log('222');
        ResourceManager.embedBundledResources();

        const obj: HTMLElement = this.$refs.dcontainer as HTMLElement;

        this.dashboardControl = new DashboardControl(obj, {
        // Specifies the URL where the Web Dashboard's server side is hosted.
            endpoint: this.$store.state.basePath + 'MyDashboard',
            workingMode: 'Viewer',
            initialDashboardId: this.Model.Contents[0].ContentId.toString()
        });

        var toolbox = this.dashboardControl.findExtension('toolbox');

        toolbox.removeMenuItem('open-dashboard');
        toolbox.removeMenuItem('create-dashboard');

        const exitItem = new DashboardMenuItem('mi_Exit', 'Exit', 10, 0);
        exitItem.click = this.Exit;
        toolbox.addMenuItem(exitItem);
        this.dashboardControl.render();
    }

    private Exit() {
        // this.$router.push(`/admin/screens/details/${this.ScreenId}`);
    }
}
